module.exports = __webpack_public_path__ + "img/892.116f63ac.png";